<script lang="ts" setup>
  import { DiscountMode } from '@othercommerce/domain';

  interface Props {
    type: DiscountMode;
    value: string | number | null | undefined;
  }

  defineOptions({
    inheritAttrs: false,
  });

  defineProps<Props>();
</script>
<template>
  <div v-if="value" class="discount-label">
    <p class="discount-label__value">
      <SfFormattedPercentage v-if="type === DiscountMode.PERCENT" :value="value" />
      <SfFormattedNumeric v-if="type === DiscountMode.FIXED" :value="value" />
    </p>
  </div>
</template>
<style lang="scss">
  :root {
    --sf-discount-label-padding-x: 0.75rem;
    --sf-discount-label-padding-y: 0.25rem;
    --sf-discount-label-radius: var(--border-radius);
    --sf-discount-label-max-width: 4rem;
    --sf-discount-label-background: var(--primary-background);
    --sf-discount-label-color: var(--primary-foreground);
    --sf-discount-label-font-size: 0.875rem;
    --sf-discount-label-line-height: 1.25;
    --sf-discount-label-font-weight: var(--font-weight-bold);
  }

  .discount-label {
    text-align: center;
    padding: var(--sf-discount-label-padding-y) var(--sf-discount-label-padding-x);
    border-radius: var(--sf-discount-label-radius);
    background-color: var(--sf-discount-label-background);
    min-width: var(--sf-discount-label-max-width);
    line-height: var(--sf-discount-label-line-height);

    &__value {
      color: var(--sf-discount-label-color);
      font-weight: var(--sf-discount-label-font-weight);
      font-size: var(--sf-discount-label-font-size);
    }
  }
</style>
